export function applyTransition(speed = 1){
	if(!this.config.options.fade && (this.reducedAnimationApplied || this.animationUnapplied)){
		let animSpeed = this.config.options.speed * speed;
		animSpeed = Math.min(Math.max(animSpeed, this.config.options.minSpeed), this.config.options.speed);
		this.elements.track.style.transition = `transform ${animSpeed}ms ${this.config.options.ease}`;
		this.reducedAnimationApplied = false;
		this.animationUnapplied = false;
	}
}

export function unapplyTransition(){
	if(!this.config.options.fade){
		this.elements.track.style.transition = 'none';
		this.animationUnapplied = true;
	}
}

export function reduceTransition(){
	if(!this.config.options.fade){
		this.elements.track.style.transition = 'transform 1ms linear';
		this.reducedAnimationApplied = true;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/animations.js